export const truncateOnWord = (str: string, n: number) => {
  if (str.length <= n) {
    return str;
  }
  const words = str.split(" ");
  let result = "";
  let i = 0;
  while (result.length + words[i].length <= n) {
    result += words[i] + " ";
    i++;
  }
  return result.trim() + "...";
};
